import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";
import VisitTracker from "@/components/VisitTracker";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import CartDrawer from "@/components/site/CartDrawer";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";

function App() {
  useLenis();

  return (
    <div className="App grain min-h-screen bg-stone text-ink">
      <BrowserRouter>
        <CartProvider>
          <VisitTracker />
          <Nav />
          <CartDrawer />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/product/:id" element={<ProductDetail />} />
          </Routes>
          <Footer />
          <Toaster position="bottom-right" />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
